import { CampaignStatus, CuredApiPaths } from 'models/enums';
import { Campaign } from 'domains/campaigns/types';
import { UseQueryOptions } from '@tanstack/react-query';
import useQuery from '../useQuery';
import QueryKeys from './keys';

type UseCampaignsOptions = {
    searchTerm?: string;
    statuses?: CampaignStatus[];
    reactQueryOptions?: UseQueryOptions<Campaign[], Error>;
};

const useCampaigns = (options: UseCampaignsOptions = {}) => {
    const { searchTerm, statuses, reactQueryOptions } = options;

    const params: Record<string, string> = {};
    if (searchTerm) {
        params.searchTerm = searchTerm;
    }
    if (statuses && statuses.length > 0) {
        params.status = statuses.join(',');
    }

    const axiosOptions = Object.keys(params).length > 0 ? { params } : {};

    return useQuery(
        QueryKeys.CAMPAIGNS(searchTerm, statuses?.join(',')),
        CuredApiPaths.CAMPAIGNS,
        reactQueryOptions,
        axiosOptions
    );
};

export default useCampaigns;
